const planCards = [
  {
    icon: "ri-group-line",
    title: "Multi-Employer Pension Plan",
    body: "The MPF is a multi-employer pension plan for eligible musicians and other eligible members. It is funded through employer contributions made under applicable agreements and administered by a Board of Trustees.",
  },
  {
    icon: "ri-coins-line",
    title: "Employer Contributions",
    body: "Employee contributions are not required or permitted. Employers contribute to the Fund on behalf of eligible members, and those contributions are held in trust to provide benefits and pay Fund administrative expenses.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Pension Benefits",
    body: "The Plan provides Normal, Early, Deferred, Special Retirement, Disability and Survivor benefits. Pension benefits are not automatic, so members must apply and submit the required forms.",
  },
];

export default function SummaryPlanSection() {
  return (
    <section id="summary-plan" className="w-full bg-[#f4f8fc] py-16 scroll-mt-14">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Eyebrow */}
        <div className="flex items-center gap-2 mb-3">
          <div className="w-6 h-0.5 bg-[#1a8fc1]"></div>
          <span className="text-[#1a8fc1] text-xs font-semibold tracking-widest uppercase">
            Plan Guide
          </span>
        </div>

        {/* Heading */}
        <h2 className="text-2xl md:text-3xl font-bold text-[#0d1f4c] mb-4">
          Summary Plan
        </h2>

        {/* Intro text */}
        <p className="text-sm text-gray-500 leading-relaxed max-w-[780px]">
          This plain-language guide outlines key provisions of the Musicians&apos; Pension Fund of Canada, including eligibility, contributions, benefit calculations, pension options, and distribution rules. Below is a quick overview of how the Plan works.
        </p>

        {/* Three overview cards */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          {planCards.map((card) => (
            <div
              key={card.title}
              className="bg-white rounded-lg border border-gray-200 border-t-[3px] border-t-[#1a8fc1] shadow-sm p-7"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#e8f4fb] mb-5">
                <i className={`${card.icon} text-xl text-[#1a8fc1]`}></i>
              </div>
              <h3 className="text-base font-semibold text-[#0d1f4c] mb-3 leading-snug">
                {card.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                {card.body}
              </p>
            </div>
          ))}
        </div>

        {/* Document item */}
        <div className="mt-8 bg-[#f8fafc] border border-gray-200 border-l-[4px] border-l-[#1a8fc1] rounded-r-lg rounded-l shadow-sm p-6 flex flex-col sm:flex-row sm:items-center gap-5">
          <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-lg bg-[#f4f8fc]">
            <i className="ri-file-pdf-2-line text-2xl text-[#1a8fc1]"></i>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-base font-semibold text-[#0d1f4c] mb-1 whitespace-nowrap">
              Plan Summary 2019
            </h3>
            <p className="text-sm text-gray-500 leading-relaxed">
              Plain-language guide to the Plan and its key provisions.
            </p>
          </div>
          <a
            href="/wp-content/uploads/2019/01/MPFCanada_PensionPlan2019-FINAL-s.pdf"
            target="_blank"
            rel="nofollow"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-[#1a8fc1] text-white text-sm font-medium rounded-lg hover:bg-[#157ba6] transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
          >
            View
            <i className="ri-external-link-line text-sm"></i>
          </a>
        </div>


      </div>
    </section>
  );
}